import React, { useState } from "react";
import {
    ThemeProvider,
    Modal,
    ModalWrapper,
    Checkbox,
    Button,
    Notification,
    ModalFooter
} from '@workboard/wobo-ui';
import styled from "styled-components";
import { TagLabel } from "../components/addkrTag.component";
import KrTagService from '../services/krTag.service';
import { 
  BrowseTagModelProps, 
  BrowseTagCategoryFilterProps, 
  BrowseTagItemListProps
 } from "../types/krTags.types";
 import { useTranslation } from 'react-i18next';
const StyledModal = styled(Modal)`
  ${ModalWrapper} { 
    width: 600px;
  }
  ${ModalFooter} { 
    button {
      height: 40px;
    }
  }`;

const BrowseTagModel = (props: BrowseTagModelProps) => {
    const [data,setData] = useState({
        showModal: false,
        categories: [],
        items: [],
        selectedTegs: [],
        selectedCategoryId: null
    });
    const [showNotif, setNotif] = useState({
      isOpen: false,
      severity: ""
    });
    const { t } = useTranslation()
    const tagService = new KrTagService();

    const showModal = () => {
      tagService.browseTag({metricId : props.metric.id, goalId:props.goalId})
      .then((response) => {
        let existingTags = props.currentTags;
        let tagData = [];
        response.data.data.tagGroups.map((x)=>{
         x.tags.map((y)=>{
            return tagData.push({id: y.id, title: y.name, category: { id: x.id } , status: false})
          })
        })
        let exid = existingTags.map((x)=>{return x.id});
        let temp = tagData.filter(item => exid.includes(item.id));
        temp.forEach((e)=>{
          e.status = true
         })
        setData((curState)=>{
          return {...data, 
          showModal: !curState.showModal,
          categories: response.data.data.tagGroups.map((x)=>{return {title: x.name, id: x.id}}),
          selectedTegs: temp,
          items: tagData
        };
        });
      })
      .catch((error) => {
        console.log(error);
      })  
    }

    const setShowModal = () => {
      setData(()=>{
          return { 
            ...data,
            showModal: false
          };
        }); 
    }

    const sendTags = (tags) =>{
      let selectTags = tags.map((x) => { return {name: x.title, id: x.id}})
      props.getTags(selectTags);
      if(data.selectedTegs.length > 0) {
        setNotif({
          isOpen: true,
          severity: "success"
        })
      }
      setData(()=>{
        return { ...data,showModal: false , selectedTegs: [] ,selectedCategoryId : null};
      }); 
    }

    const onSelectCategory = (id) => {
      setData({
       ...data, selectedCategoryId: id
      });
    }

    const changeStatus = (teg) => {
      let itemss =  [...data.items];
      
      let i = itemss.findIndex(x => x.id === teg.id);
      itemss[i].status = !teg.status;
      // set focus to second last element if last is deleted.
      // if(i === items.length - 1){
      //   let el = document.querySelector(".browse-tag-zindex .selected-tags");
      //   el.querySelector<HTMLInputElement>(`#${i}`)?.focus();
      // }
      setData({
        ...data,items, selectedTegs: itemss.filter((x) => {return x.status === true})
      });
    }

    const handleUserKeyPressDelete = (e,item) => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        changeStatus(item);
      }
    }
    const modelFooter = (data) => {
      return (
        <div>
        {
          categories.length > 0 ?  <div className={'custom-model-footer'}>
        <Button variant="ghost" data-testid="goback-button" onClick={data.onDismiss}>
          {t('Cancel')}
        </Button>
        <Button variant="primary"  data-testid="add-button" onClick={data.onSubmit}>
          {t('Add')}
        </Button>
      </div>:""}
      </div>
      )
    }

    const { categories, items, selectedCategoryId} = data;
    const deafultCategory = categories[0];
    const selectedCategory = categories.find(i => i.id === selectedCategoryId) || deafultCategory; 

    return (
      <>
        <Button
          kind="normal"
          onClick={showModal}
          variant="ghost"
          className="browse-button"
          data-testid="browseTag-btn"
        >
          {t('Browse tags')}
        </Button>
        <ThemeProvider>
        <StyledModal 
          title={t('Browse tags')}
          isOpen={data.showModal}
          onDismiss={setShowModal}
          onSubmit={()=>sendTags(data.selectedTegs)}
          className="browse-tag-zindex"
          data-testid="browseTag-modal" // Automation id example.
          actions={modelFooter}
        >
          <div >
            <div style = {{width: '100%' }}>
              <p >{categories.length >0 ?t("Browse and add tags from the list below."):t("No tags found")}</p>
            </div>
            <div style = {{height: '250px', width: '100%'}}>
              <div style = {{width: '29%', display: 'block', borderRight : '1px solid #D7DDE5', height: '100%',float: 'left', overflowY: 'auto'}} >
              <CategoryFilter categories={categories} onSelectCategory={onSelectCategory} items = {data.items} />
              </div>
              <div style = {{width: '70%', display: 'block', height: '100%',float: 'left', overflowY: 'auto',paddingTop: '5px'}}>
                <div style= {{paddingLeft: '10px'}}>
                <ItemList items={items} selectedCategory={selectedCategory} changeStatus = {changeStatus} />
                </div>
              </div>
            </div>
            <div style = {{width: '99%'}}>
              {data.selectedTegs.length>0 && (
            <div style= {{paddingTop: '10px'}}>
            <p data-testid="selectedTags" style={{margin: "10px 10px 10px 0px"}}>({data.selectedTegs.length}) {t('selected tags')}:</p>
            <div className="selected-tags" style= {{maxHeight: '100px', overflowY:'auto',padding:"10px"}}>
                {data.selectedTegs.map((item, index) =>(
                   <TagLabel
                   name={item.title}
                   id={index}
                   deleteFunction={() => changeStatus(item)}
                   handlekey={(e)=>handleUserKeyPressDelete(e,item)}
                 />
                ))}</div>
                </div>)}
            </div>
          </div>
        </StyledModal>
        {props.closeToastMessage==false &&
        <Notification
          open={showNotif.isOpen}
          message={'Success! Tags have been added to key result.'}
          severity={showNotif.severity}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          onClose={() => setNotif({
            isOpen: false,
            severity: ""
          })}
        />}
        </ThemeProvider>
      </>
    );
}

const CategoryFilter = ({ categories, onSelectCategory, items } : BrowseTagCategoryFilterProps) => {
  const [textColor,setTextColor] = useState({lColor : 'green', lId: 0});
  const clickHandler = (id,index) => {
    onSelectCategory(id);
    setTextColor({...textColor,lColor:'blue',lId: index});
    $('#tag-group-'+index).focus();
  }
  
  const handleUserKeyPress = (e,id,index) => {
    if (e.keyCode === 40) {
      let newData = categories.filter((i: any ,key: number) => (index +1 == key));
      if(newData.length > 0)
      {
        clickHandler(newData[0].id, index+1) 
      }
      else 
      clickHandler(id,index)
    }
    if (e.keyCode === 38) {
      let newData = categories.filter((i: any ,key: number) => (index-1 == key));
      if(newData.length > 0)
      {
        clickHandler(newData[0].id, index-1) 
      } else
      clickHandler(id,index)
    }
    if (e.keyCode === 13) {
      clickHandler(id,index)
    }
  };

  const links = categories.map((i: any ,index: number) => (
    <div id={`tag-group-${index}`} className="tag-group" data-testid="tag-group" key={i.id}  tabIndex={index == textColor.lId ? 0 : -1} role = {"button"} aria-label={i.title}  onClick={() => clickHandler(i.id,index)} onKeyUp={(e) => handleUserKeyPress(e,i.id,index)} style = {{margin:'5px', display:'inline-flex', color : index == textColor.lId ? '#007FAD':'#333943' , cursor: 'pointer'}}>
    <div style = {{width: '120px', float: 'left'}}>
    { (i.title.length >11) ? i.title.substr(0,8) + '...' : i.title } ({(items.filter((x) => {  return x.category.id == i.id})).length}) 
    </div>
    <span style = {{marginRight: '20px', float: 'right', padding: '5px'}}><img style = {{width: '7px',marginBottom: '3px',}} src = {wbConfig.baseUrl + (index == textColor.lId ? '/images/arrow_blue_right.png' :'/images/arrow_right.png') }/></span>
  
</div>
  ));
  return (
    <div>
      { 
        links 
      }
    </div>
  )
};
  
const ItemList = ({items, selectedCategory, changeStatus}: BrowseTagItemListProps) => {
  
  const currentItems = items
    .filter(i => i.category.id === selectedCategory.id)
    .map(i => (
      <div key={i.id} tabIndex={-1} style={{marginRight: "10px"}} >
        <Checkbox  
        data-testid="ui-tag" 
        className="browse-checkbox" 
        isDisabled={false} 
        label={ (i.title.length > 43) ? i.title.substr(0,42) + '...' : i.title } 
        isChecked={i.status} 
        onChange={()=> changeStatus(i)}
        animation
        />
      </div>
    ));
  return (
    <div>
      { 
        currentItems 
      } 
    </div>
  );
};

export default BrowseTagModel;